import { ReplicaType } from "types";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp5-the-boy-who-lies-alternative",
  name: `The Daily Prophet\n'The Boy Who Lies?' (alternative)`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'The Boy Who Lies?' (alternative)",
  },
  origin: "Harry Potter and the Order of the Phoenix",

  category: replicaCategories.harryPotter,

  versions: [Version2],
};

export default data;
